export default {"src":"/_next/static/media/shipment-Calc-icon.450e4649.svg","height":31,"width":28};